import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/core/user/user.service';
import { CommonComponent } from '../common-component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { User } from 'src/core/user/user.types';
import { AuthService } from 'src/core/auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, finalize, takeUntil, takeWhile, timer } from 'rxjs';

@Component({
  selector: 'app-menu-header',
  templateUrl: './menu-header.component.html',
  styleUrls: ['./menu-header.component.scss']
})
export class MenuHeaderComponent extends CommonComponent implements OnInit
{
  @ViewChild('itemsMenu') itemsMenu: ElementRef;
  isCollapsed: boolean = false;
  rolVet = '[ROLE_SUSCRIPTOR]';
  rolClient = '[ROLE_CLIENTE]';
  userSession = {} as User;
  menu = [];
  optionSelected = 0;
  menuPublic = [
    {title: 'Inicio', path:'/public/home'},
    {title: 'Blog', path:'https://pet24app.wixsite.com/pet24', link: true},
    {title: 'Nosotros', path:'/public/about-us'},
  ];
  menuVets = [
    {title: 'Inicio', path:'/vets/home'},
    {title: 'Solicitud de Citas', path:'/vets/appointment-request'},
    {title: 'Citas Programadas', path:'/vets/scheduled-appointments'},
    {title: 'Historial de Citas', path:'/vets/appointment-history'},
  ];
  menuClient = [
    {title: 'Inicio', path:'/client/home'},
    {title: 'Gestión de Citas', path:'/client/appointment-management/new-appointment'},
    {title: 'Radar Mascotas', path:'/client/radar-mascotas'},
    {title: 'Cuenta', path:'/client/account'},
    {title: 'Blog', path:'https://pet24app.wixsite.com/pet24', link: true},
    {title: 'Nosotros', path:'/public/about-us'},
  ]


  constructor(
    private _userService: UserService,
    private _authService: AuthService,
    private _router: Router,
    _snackBar: MatSnackBar
  ){
    super(_snackBar);
  }
  ngOnInit(): void {
    this.getUserSession();
    this.getRouteNavigation();
  }

  getUserSession(){
    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
        if(this.userSession === null){
          this.menu = this.menuPublic;
        }else if(this.userSession?.rol === this.rolClient){
          this.menu = this.menuClient;
        }else if(this.userSession?.rol === this.rolVet){
          this.menu = this.menuVets;
        }
      },
      error: (error: any) => {
        this.openSnackBar(JSON.stringify(error));
      }
    });
  }

  closeSesion(){
    this._authService.signOut();
    this._router.navigate(['auth/sign-in']);
    this.menu = this.menuPublic;
  }

  getRouteNavigation(){
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let url = event.url.split('?')[0];
        this.menu.forEach((item, index) => {
          if(item.path === url){
            this.optionSelected = index;
          }
        });
      }
    });
  }

  clickOption(id: number){
    this.optionSelected = id;
  }
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  toggleCollapseItemsMenu() {
    if(this.isCollapsed){
      this.isCollapsed = !this.isCollapsed;
    }
  }
}
